import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import ExamTitle from '../examsGeneralComponents/ExamTitle'
import LinearProgress from '@material-ui/core/LinearProgress'
import ExamQuestionHeader from '../examsGeneralComponents/ExamQuestionHeader'
import QuizQuestion from './QuizQuestion'
import QuizAnswers from './QuizAnswers'
import QuizSubmitAnswerOrSkip from './QuizSubmitAnswerOrSkip'
import { useSnackbar } from 'notistack'
import { Typography } from '@material-ui/core'
import { useMutation, useLazyQuery, useQuery } from '@apollo/react-hooks'
import { courseMutations } from '../../graphql/mutations'
import * as loggerClient from '../../services/loggerClient'
import { examsPropertiesQueries, coursesQueries } from '../../graphql/queries'
import QuizResultTitle from './QuizResultTitle'
import QuizResultsLegend from './QuizResultsLegend'
import AllQuizResults from './AllQuizResults'
import PDFButton from '../PDFButton'
import ContentPrintWrapper from '../ContentPrintWrapper'
import Container from '@material-ui/core/Container'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    backgroundColor: 'unset',
    width: '100%',
    height: '100%',
    padding: '24px 32px',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    overflow: 'auto',
    '@media (max-width: 1050px)': {
      padding: 0
    },
    '& > button': {
      marginLeft: 28,
      marginBottom: 100
    }
  },
  wrapper: {
    width: '100%'
  },
  skipButton: {
    '@media(max-width: 1050px)': {
      width: '100%'
    }
  }
}))

const QuestionBlock = styled.div`
  padding: 32px 32px 8px;
  &.isQuestion {
    background-color: #f2f2f2;
  }
`

const AnswersBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 32px 32px;
  margin-top: 16px;
`

const QuizStructure = ({ content, type, courseId, nextContent, id,presentation}) => {
  const classes = useStyles()
  const [questionNumber, setQuestionNumber] = useState(-1)
  const [answersList, setAnswersList] = useState([])
  const [selectedAnswer, setSelectedAnswer] = useState('')
  const [loading, setLoading] = useState(false)
  const [showResults, setShowResults] = useState(false)
  const [showAnswers, setShowAnswers] = useState(false)
  const [answerContent, setAnswerContent] = useState(null)
  const { enqueueSnackbar } = useSnackbar()
  var listOfSelectedAnswers = []
  const isLastQuestion = questionNumber + 1 === content.perguntas.length ? true : false
  const isFirstQuestion = questionNumber - 1 === -1 ? true : false
  let currentQuestion = content.perguntas !== null ? content.perguntas[questionNumber] : ''
  const quizType = (content || {}).__typename

  const [respondePerguntaQuiz] = useMutation(courseMutations.ANSWER_QUIZ_QUESTION, {
    update(cache, { data: { respondePerguntaQuiz } }) {
      // openModal(respondePerguntaQuiz)
      setAnswerContent({...respondePerguntaQuiz, selectedAnswer})      
    }
  })

  const [loadDataInicio, { data: dataInicio }] = useLazyQuery(examsPropertiesQueries.GET_DATE_START, { fetchPolicy: 'network-only' })

  const { data: dataTodasRespostas } = useQuery(coursesQueries.GET_ALL_ANSWERS, {
    variables: { pergunta_id: currentQuestion?._id || '' }
  })

  const finishQuiz = (selectedAnswer, dataInicio, content) => {
    setShowResults(true)

    if (!presentation) {
      id && courseId && adicionaProgresso({
            variables: {
                conteudoId:id,
                cursoId:courseId
            }
        })
    }

  }

  const [adicionaProgresso] = useMutation(courseMutations.ADD_PROGRESS)
  
  const handleSelectedAnswer = (value, dateStart, content) => {
    if (!value) {
      enqueueSnackbar('Por favor, escolha uma das opções.', { variant: 'info', anchorOrigin: { vertical: 'bottom', horizontal: 'left' } })
      return null
    }
    const dataHora = parseInt(dateStart.dataInicio, 10)
    const newData = new Date(dataHora).toISOString()
    const origem = content?.conteudo_id
    const contexto = 'curso'
    const conteudo = ''
    const tipo = 'quiz'
    const perguntaId = currentQuestion?._id

    loggerClient.onShowTestResult({
      conteudo: conteudo,
      pergunta: perguntaId,
      tipo: tipo,
      origem: origem,
      contexto: contexto,
      inicio: newData,
      resposta: value
    })

    respondePerguntaQuiz({
      variables: {
        cursoId: courseId,
        conteudoId: id,
        perguntaId: currentQuestion._id,
        respostaId: value
      }
    })
  }

  const questionsNavigation = (input, value, dateStart, content, certa) => {
    if ((currentQuestion || {})._id && certa === undefined) {
      const dataHora = parseInt(dateStart.dataInicio, 10)
      const newData = new Date(dataHora).toISOString()

      const origem = content.conteudo_id
      const contexto = 'curso'
      const conteudo = ''
      const tipo = 'quiz'
      const perguntaId = currentQuestion._id

      const resposta = () => {
        if (input === 'back') return 'questao_anterior'
        if (input === 'next') return 'proxima_questao'
        if (input === 'jump') return 'questao_pulada'
        if (input === 'finish') return 'quiz_finalizado'
      }

      loggerClient.onShowTestResult({
        conteudo: conteudo,
        pergunta: perguntaId,
        tipo: tipo,
        origem: origem,
        contexto: contexto,
        inicio: newData,
        evento: resposta()
      })
    }

    setLoading(true)
    if (input === 'back') {
      setQuestionNumber(questionNumber - 1)
    } else {
      setQuestionNumber(questionNumber + 1)
    }
    setSelectedAnswer('')
    setTimeout(() => {
      setLoading(false)
    }, 20)
  }

  const onChange = answer => {
    listOfSelectedAnswers = [...answersList]
    listOfSelectedAnswers[questionNumber] = answer
    if (answersList[questionNumber]) {
      listOfSelectedAnswers[questionNumber] = null
      setAnswersList(listOfSelectedAnswers)
    }
    setSelectedAnswer(answer)
  }

  const todasRespostasPerguntas = () => {
    if (showAnswers) {
      return dataTodasRespostas
    } else {
      return false
    }
  }

  useEffect(() => {
    loadDataInicio()
    setShowAnswers(false)
  }, [questionNumber]) //eslint-disable-line

  useEffect(() => {
  //eslint-disable-next-line
    listOfSelectedAnswers = [...answersList]
    listOfSelectedAnswers[questionNumber] = answerContent
    setAnswersList(listOfSelectedAnswers)
  }, [answerContent]) 

  if (loading)
    return (
      <Container className={classes.root}>
        <Paper className={classes.wrapper}>
          <QuestionBlock className={'isQuestion'}>
            <Typography gutterBottom variant="h5" component="h1" className={classes.title}>
              {`${content.tipo.toUpperCase()} - ${content.titulo}`}
            </Typography>
          </QuestionBlock>
          <AnswersBlock>
            <LinearProgress className={classes.loadingProgress} />
          </AnswersBlock>
        </Paper>
      </Container>
    )

  if (showResults) 
      return (
        <Container className={classes.root}>
          <PDFButton finalAnswers={answersList} content={id} />
          <ContentPrintWrapper>
            <Paper className={classes.wrapper}>
              <QuestionBlock className={'isQuestion'}>
                <QuizResultTitle type="Quiz" title={content.titulo} numberOfQuestions={content?.perguntas.length} />
              </QuestionBlock>
              <AnswersBlock>
                <QuizResultsLegend/>
                <AllQuizResults finalAnswers={answersList} questions={content?.perguntas} content={content?.conteudo_id} />
              </AnswersBlock>
            </Paper>
          </ContentPrintWrapper>
        </Container>
      )

  return (
    <Container className={classes.root}>
      <Paper className={classes.wrapper}>
        <QuestionBlock className={questionNumber > -1 ? 'isQuestion' : ''}>
          <ExamTitle type="Quiz" title={content.titulo} />
          <Typography gutterBottom variant="body1" component="span">
            {questionNumber >= 0 ? `Pergunta ${questionNumber + 1} de ${content.perguntas.length}` : `${content.perguntas.length} perguntas`}
          </Typography>
          <ExamQuestionHeader
            content={content}
            questionNumber={questionNumber}
            currentQuestion={currentQuestion}
            testInfo={(currentQuestion || {}).prova}
            type="quiz"
          />
          {questionNumber < 0 ? '' : <QuizQuestion questionContent={currentQuestion} />}
        </QuestionBlock>
        <AnswersBlock>
          {questionNumber < 0 ? (
            <QuizSubmitAnswerOrSkip
              questionNumber={questionNumber}
              questionsNavigation={(input) => questionsNavigation(input, selectedAnswer, dataInicio, content)}
              value={answersList}
              isLastQuestion={isLastQuestion}
              courseId={courseId}
              nextContent={nextContent}
            />
          ) : (
            <>
              <QuizAnswers
                answersContent={currentQuestion}
                onChange={onChange}
                value={selectedAnswer}
                quizType={quizType}
                selectedAnswer={(answersList || []).map(row => row)}
                questionNumber={questionNumber}
                answerFeedback={answerContent}
                showAnswers={todasRespostasPerguntas()}
              />
              <QuizSubmitAnswerOrSkip
                questionNumber={questionNumber}
                questionsNavigation={(input) => questionsNavigation(input, selectedAnswer, dataInicio, content)}
                handleSelectedAnswer={() => handleSelectedAnswer(selectedAnswer, dataInicio, content)}
                value={answersList.map(row => row)}
                onChange={onChange}
                isLastQuestion={isLastQuestion}
                isFirstQuestion={isFirstQuestion}
                courseId={courseId}
                nextContent={nextContent}
                showAnswers={() => setShowAnswers(!showAnswers)}
                isAnswersOn = {showAnswers}
                handleFinishQuiz={() => finishQuiz()}
              />
            </>
          )}
        </AnswersBlock>
      </Paper>
    </Container>
  )
}

export default QuizStructure
